import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mergeWarningText: {
    id: 'frontbucket.repository.pullRequest.mergeWarningText',
    description: 'Text of merge warning',
    defaultMessage:
      'The source branch has failed merge checks that need to be resolved.',
  },
  pendingMergeWarningText: {
    id: 'frontbucket.repository.pullRequest.pendingMergeWarningText',
    description: 'Text of merge warning',
    defaultMessage:
      ' Select the { merge } button to automatically merge this pull request when builds pass.',
  },
  mergeWarningTitle: {
    id: 'frontbucket.repository.pullRequest.mergeWarningTitle',
    description: 'Title of merge warning',
    defaultMessage:
      '{countFailedChecks, plural, one {{countFailedChecks} merge check has not passed} other {{countFailedChecks} merge checks have not passed}}',
  },
  pendingMergeWarningTitle: {
    id: 'frontbucket.repository.pullRequest.pendingMergeWarningTitle',
    description: 'Title of pending merge warning',
    defaultMessage: 'Builds not completed',
  },
  unableToMergeTitle: {
    id: 'frontbucket.repository.pullRequest.mergeDialog.unableToMergeTitle',
    description: 'Title of unable to merge warning',
    defaultMessage: 'Unable to merge',
  },
  failedPreMergeChecksDescription: {
    id: 'frontbucket.repository.pullRequest.mergeDialog.failedPreMergeChecksDescription',
    description: 'Description of failed pre-merge checks',
    defaultMessage:
      'The following {checkType} pre-merge {total, plural, one {check} other {checks}} did not pass:',
  },
  required: {
    id: 'frontbucket.repository.pullRequest.mergeDialog.required',
    description: 'Required',
    defaultMessage: 'required',
  },
  recommended: {
    id: 'frontbucket.repository.pullRequest.mergeDialog.recommended',
    description: 'Recommended',
    defaultMessage: 'recommended',
  },
  reviewFailedPreMergeChecksDescription: {
    id: 'frontbucket.repository.pullRequest.mergeDialog.reviewFailedPreMergeChecksDescription',
    description: 'Description of review failed pre-merge checks',
    defaultMessage:
      'Review the merge {total, plural, one {check} other {checks}} and resolve any necessary issues before attempting to merge.',
  },
});
